import React from 'react'
import styles from './index.module.scss'
import { withRouter } from 'react-router-dom'
const ChangeInfo = props => {
    function whichPage () {
        let pathName = '';
        props.history.location.pathname.match(/superMember/) ? pathName = 'superMember' : pathName = 'home';
        return pathName;
    }
    return (
        <div className={`${styles.blockArea} 
                         ${styles.wordBlock} 
                         ${whichPage() === 'superMember' ? styles.superBackground : ''}`}>
            <div className={styles.wordContain}>
                <div className={styles.title}>关于会员改版升级的相关说明</div>
                <div className={styles.wordItem}>
                    <span>1·</span>
                    <span>【青春会员】: 如果您已经是青春会员用户，在原有权益基础上，我们将向您的账户额外赠送10本英文原著，享有当前【成长会员】的所有权益。</span>
                </div>
                <div className={styles.wordItem}>
                    <span>2·</span>
                    <span>【书城会员】: 如果您已经是书城会员用户，原有的权益可以持续享有，重新购买【成长会员】和【荣耀会员】，购买后相关权益进行叠加。</span>
                </div>
                <div className={styles.wordItem}>
                    <span>3·</span>
                    <span>【课程会员】: 如果您已经是课程会员用户，将为您免费升级荣耀会员，在之前购买的有效期内享有【荣耀会员】所有权益。</span>
                </div>
                <div className={styles.wordItem}>
                    <span>4·</span>
                    <span>【超级会员】: 如果您已经是超级会员用户，享有当前【荣耀会员】的所有权益。</span>
                </div>
                {/* <div className={styles.wordItem}>
                    <span>5·</span>
                    <span>【成长会员】: 加入VIP训练营方式：添加词霸老师微信（jingpinke009），提供购买记录即可；</span>
                </div>
                <div className={styles.wordItem}>
                    <span>6·</span>
                    <span>【荣耀会员】: VIP训练营相关问题，请添加词霸老师微信（jingpinke009），提供购买记录即可；</span>
                </div> */}
            </div>
        </div>
    )
}
export default withRouter(ChangeInfo);